<template>
  <div class="title">
    <div class="title-text">{{ titleText }}</div>
    <div class="title-line"></div>
    <div class="sub-title-text">{{ subTitleText }}</div>
  </div>
</template>

<script>
import FunctionList from 'Assets/mockData/FunctionList.json';
export default {
  name: 'Title',
  data() {
    return {
      routePath: this.$route.path.split('/')[1],
      page: this.$route.query.page,
      functionList: FunctionList,
    };
  },
  computed: {
    titleText() {
      let title = '';
      this.functionList.forEach((item) => {
        if (item.id === this.routePath) {
          title = item.name;
        }
        return;
      });
      return title;
    },
    subTitleText() {
      let subTitle = '';
      this.functionList.forEach((item) => {
        if (item.id === this.routePath) {
          item.subList.forEach((subItem) => {
            if (subItem.subId === this.page) {
              subTitle = subItem.subName;
              return;
            }
          });
          return;
        }
      });
      return subTitle;
    },
  },
  watch: {
    $route() {
      this.routePath = this.$route.path.split('/')[1];
      this.page = this.$route.query.page;
    },
  },
};
</script>
<style scoped>
.title {
  margin: 20px 20% 0 20%;
  text-align: left;
}
.title-text {
  font-weight: bold;
  font-size: 36px;
  padding: 0 0 10px 0;
}
.title-line {
  border-top: 1px solid;
  border-color: #000000;
  width: 35%;
}
.sub-title-text {
  font-size: 30px;
  padding: 10px 0 10px 0;
}
@media (max-width: 767px) {
  .title {
    margin: 70px 0px 20px 0px;
  }
  .title-text {
    font-size: 30px;
    padding: 20px 0 10px 0;
  }
  .title-line {
    width: 100%;
  }
  .sub-title-text {
    font-size: 24px;
    padding: 10px 0 30px 0;
  }
}
</style>
